// extracted by mini-css-extract-plugin
export var brand = "styles-module--brand--greJP";
export var hiddenContent = "styles-module--hiddenContent--3m_QM";
export var spacer = "styles-module--spacer--nszfJ";
export var toggle = "styles-module--toggle--2V_i6";